import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Box, Typography } from '@mui/material'

import { AccountBalanceWallet, Redeem } from '@mui/icons-material'
import { InfoPlayer } from '@/views/components'
import { ApplicationState } from '@/state/root.models'
import useDialog from '@/hooks/ui/use-dialog.hook'
import { DialogsEnum } from '@/enums'
import { DialogManualDebitCreditForm } from '../dialogs'

export const PlayerBalance = () => {
  const { t } = useTranslation()
  const { handleDialogAction } = useDialog()

  const { wallet: playerCardState } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )

  const { currentWallet } = useSelector(
    ({ wallet }: ApplicationState) => wallet,
  )

  const infoArray = [
    {
      icon: <AccountBalanceWallet />,
      title: t('labels.realMoney'),
      click: () =>
        handleDialogAction({
          open: true,
          id: DialogsEnum.DIALOG_MANUAL_DEBIT_CREDIT,
        }),
      data: (
        <Box sx={{ display: 'flex', gap: 1 }}>
          {playerCardState?.currency && (
            <Typography variant="caption" component="span">
              {playerCardState.currency}
            </Typography>
          )}
          <Typography variant="caption" component="span">
            {playerCardState?.balance || 0}
          </Typography>
        </Box>
      ),
    },
    {
      icon: <Redeem />,
      title: t('labels.bonusMoney'),
      data: (
        <Box sx={{ display: 'flex', gap: 1 }}>
          {playerCardState?.currency && (
            <Typography variant="caption" component="span">
              {playerCardState.currency}
            </Typography>
          )}
          <Typography variant="caption" component="span">
            {currentWallet?.bonusBalance
              ? Number(currentWallet?.bonusBalance).toFixed(2)
              : 0}
          </Typography>
        </Box>
      ),
    },
  ]

  return (
    <Box>
      <Typography fontWeight={700} paragraph>
        {t('labels.balance')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          width: '100%',
        }}
      >
        {infoArray.map((item) => (
          <InfoPlayer key={item.title} {...item} sxProps={{ width: '48.2%' }} />
        ))}
      </Box>
      <DialogManualDebitCreditForm />
    </Box>
  )
}
